import { SymbolFactory, SymbolFactoryProps } from './symbol-factory';
import { iconMap, type Icons, IconMap, deprecatedIconMap } from './icon-map';

const icons = iconMap as unknown as IconMap;
const depIcons = deprecatedIconMap as unknown as IconMap;

export type IconProps = SymbolFactoryProps<Icons>;
export const Icon = SymbolFactory<Icons>(icons, depIcons, '1.5rem');
export { Icons };
